$('.js-full').click(function() {
    $('.js-full-screen').toggleClass('open');
    $('body').addClass('fixed-position-modal');
});

$('.js-close-zoom-sl').click(function() {
    $('.js-full-screen').removeClass('open');
	if ($('.b-modal-exponat').hasClass('hide') || !($('.b-modal-exponat').length)) {
    	$('body').removeClass('fixed-position-modal');
	}
});



// WEBPACK FOOTER //
// ./src/js/pages/page-video/full-sl-img.js